import React, { useCallback, useEffect, useState } from 'react'
import { Template } from '../../Components/Template/template'
import {
    AlertType, KEY_CODE_ENTER, classBorderLabelDark, classDivBackground, classDivBody,
    classDivTitulo, classInput, classInputDark, classLabel, classLabelDark, classbtColunasAzul
} from '../../Utils/Types'
import { IoCreate } from 'react-icons/io5'
import { ModalBuscaProduto } from '../../Components/Modal/modal-busca-produto'
import { VendasService } from './vendasService'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Funcoes } from '../../Utils/Funcoes'
import { ModalCancelVendaItem } from '../../Components/Modal/modal-cancelItemVenda'
import { ModalDesconto } from '../../Components/Modal/modal-venda-desconto'
import { ModalIdentificarCliente } from '../../Components/Modal/modal-identificar-cliente'
import { ModalCancelarIdentificacao } from '../../Components/Modal/modal-cancelIdentificacao'
import { ModalFecharVenda } from '../../Components/Modal/modal-fechar-venda'
import { MdOutlinePersonOff, MdPersonSearch, MdPointOfSale } from 'react-icons/md'
import { TbPackageOff, TbShoppingCartOff } from 'react-icons/tb'
import { LuPackageSearch } from 'react-icons/lu'
import { ModalAbrirGradeVenda } from '../../Components/Modal/modal-abrir-grade-venda'
import { Tooltip } from 'react-tooltip'
import { ClientesService } from '../Clientes/ClientesService'
import { ModalExcluirDados } from '../../Components/Modal/ModalExcluirDados'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectUser } from '../../Components/Redux/userSlice'


export const LancaVendasCondicional = React.memo(() => {

    const [visibleBuscarProd, setVisibleBuscarProd] = useState(false)
    const [visibleCancelItemVenda, setVisibleCancelItemVenda] = useState(false)
    const [visibleIdentificarCli, setVisibleIdentificarCli] = useState(false)

    const [loadingCancelItemVenda, setLoadingCancelItemVenda] = useState(false)
    const [loadingIdentifcarCli, setLoadingIdentificarCli] = useState(false)

    const [visibleMsg, setVisibleMsg] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    const [totalItens, setTotalItens] = useState(0)
    const [subTotal, setSubTotal] = useState(Funcoes.numberFormat(0, "currency"))
    const [subTotalCopy, setSubTotalCopy] = useState(Funcoes.numberFormat(0, "currency"))

    const [prodVendas, setProdVendas] = useState<any[]>([])
    const [dadosCliente, setDadosCliente] = useState([])

    const { idDaVenda } = useParams<string>()
    const [idVenda, setIdVenda] = useState(0)
    const [numItem, setNumItem] = useState(0)
    const [codBarra, setCodBarra] = useState("")
    const [idCli, setIdCli] = useState(0)

    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(0)
    const [linhasCanceladas, setLinhasCanceladas] = useState<any>([])

    const [visible_Modal_Abrir_Grade_Venda, setVisible_Modal_Abrir_Grade_Venda] = useState(false)
    const [idProd, setIdProd] = useState(0)

    let user = useSelector(state => selectUser(state))

    //--------------------------------------------------------------------------- MODAL ---------------------------------------------------------------------------
    const tirarFocus = () => {

        document.activeElement instanceof HTMLElement && document.activeElement.blur(); // função para tirar o focus do input do codigo de barras
    }

    const abrirBuscarProduto = () => {

        if (loading === false) {

            if (messageType === "DANGER") {
                setVisibleMsg(false)
            }

            tirarFocus()
            setVisibleBuscarProd(true)

            const timer = setTimeout(() => {
                setCodBarra(codBarra.replace(/[^\d*]/g, ''))
                clearTimeout(timer)
            }, 0)
        }
    }

    const abrirModalGrade = useCallback(() => {
        setVisible_Modal_Abrir_Grade_Venda(true)
    }, [])

    const abrirIdentificarCliente = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (loading === false) {

            if (idVenda === 0) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("É necessário abrir uma venda para identificar o cliente")
                    clearTimeout(timer)
                }, 250)

            } else {

                tirarFocus()
                setVisibleIdentificarCli(true)
            }
        }
    }

    const abrirModalCancelarVendaItem = () => {

        if (messageType === "DANGER") {
            setVisibleMsg(false)
        }

        if (numItem > 0) {

            tirarFocus()
            setVisibleCancelItemVenda(true)

        } else {

            const timer = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage("Selecione um item para realizar o cancelamento")
                clearTimeout(timer)
            }, 250)

        }
    }

    //------------------------------------------------------------------------------ FUNÇÕES RELACIONADAS AO MODAL BUSCAR PRODUTO E GRADE --------------------------------------------------------------
    const preencherDados = useCallback(async (codBarraBuscaProd: string) => {

        setVisibleMsg(false)
        setLoading(true)

        try {

            setCodBarra(codBarra.replace(/(\*).*/, "$1") + codBarraBuscaProd)

            if (idVenda === 0) {

                const resp = await VendasService.SaveVenda()

                if (resp.error) {

                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Erro ao abrir a venda")

                } else {

                    setIdVenda(resp.data.id || 0)
                    salvarVendaItemPreenchido(codBarraBuscaProd, resp.data.id)
                }

            } else {

                salvarVendaItemPreenchido(codBarraBuscaProd, idVenda)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Ocorreu um erro ao selecionar o produto. Por favor, tente novamente")
            setCodBarra("")
            setLoading(false)
        }

    }, [idVenda, prodVendas, codBarra])

    const salvarVendaItemPreenchido = async (codBarraBuscaProd: string, id_venda_preenchido: number) => {

        setVisibleMsg(false)

        try {

            const numItem = prodVendas.length + 1

            const match = codBarra.match(/^\d+\*/)

            const numero = match ? match[0].slice(0, -1) : ''

            let itens: any = {
                id_venda: id_venda_preenchido,
                cod_barra: codBarraBuscaProd,
                qtde: parseInt(numero) || 1,
                //numItem: numItem
            }

            const resp = await VendasService.SaveItemVenda(itens)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                let itensLista: any = {
                    id_venda: resp.data.venda.id,
                    id_produto: resp.data.v_item.id_produto,
                    desc_prod: resp.data.v_item.desc_prod,
                    cod_barra: codBarraBuscaProd,
                    qtde: parseInt(numero) || 1,
                    vl_unit: resp.data.v_item.vl_unit || 0,
                    vl_tot: resp.data.v_item.vl_tot || 0,
                    numItem: numItem
                }

                setProdVendas([itensLista, ...prodVendas])

                setTotalItens(resp.data.venda.qtd_itens)
                setSubTotal(Funcoes.numberFormat(resp.data.venda.vl_liquido, 'currency'))
                setSubTotalCopy(Funcoes.numberFormat(resp.data.venda.vl_bruto, 'currency'))

                setVisibleBuscarProd(false)
                setVisible_Modal_Abrir_Grade_Venda(false)
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao lançar o produto")

        } finally {

            setCodBarra("")
            setLoading(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const fecharModalBuscarProduto = useCallback(() => {
        setVisibleBuscarProd(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)

    }, [])

    const dadosDoProd = useCallback((dadosId: number) => {
        setIdProd(dadosId)
    }, [])

    const fecharModalGrade = useCallback(() => {
        setVisible_Modal_Abrir_Grade_Venda(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            const inputElement = document.getElementById("inputCodBarra")
            inputElement?.focus()
            clearTimeout(timer)
        }, 0)

    }, [])

    //-------------------------------------------------------------------------------- FUNÇÕES RELACIONADAS AO MODAL IDENTIFICAR CLIENTE E CANCELAR IDENTIFICAÇÃO --------------------------------------------------------------
    const identificarConsumidor = useCallback(async (dadosConsumidor: any) => {

        setVisibleMsg(false)
        setLoadingIdentificarCli(true)

        try {

            let itens: any = {
                id_venda: idVenda,
                id_consumidor: dadosConsumidor.id_consumidor,
                nome_consumidor: dadosConsumidor.nome_consumidor,
                doc: dadosConsumidor.doc,
                logradouro: dadosConsumidor.logradouro,
                bairro: dadosConsumidor.bairro,
                numero: dadosConsumidor.numero,
                complemento: dadosConsumidor.complemento,
                uf: dadosConsumidor.uf,
                id_cidade: dadosConsumidor.id_cidade,
                observacao: dadosConsumidor.observacao,
                cep: dadosConsumidor.cep,
                idVendedor: dadosConsumidor.idVendedor,
                nomeVendedor: dadosConsumidor.nomeVendedor
            }

            setDadosCliente(itens)
            setIdCli(dadosConsumidor.id_consumidor)

            const resp = await VendasService.IdentificarConsumidorVenda(itens)

            if (resp.error) {

                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(resp.msg || "")

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage("Sucesso na identificação")

                setVisibleIdentificarCli(false)

                const timer = setTimeout(() => {
                    Inputfocus()
                    clearTimeout(timer)
                }, 0)

                if (idDaVenda && parseInt(idDaVenda) > 0) {

                    setVisibleMsg(true)
                    setMessageType("SUCCESS")
                    setMessage("Sucesso no teste")

                }

            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro na identificação do consumidor")

        } finally {
            setLoadingIdentificarCli(false)
        }

    }, [idVenda])

    const fecharModalIdentificacaoCliente = useCallback(() => {

        setVisibleIdentificarCli(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)

    }, [])

    //-------------------------------------------------------------------------------- FUNÇÕES RELACIONADAS AO MODAL CANCELAR VENDA ITEM --------------------------------------------------------------
    const cancelarVendaItem = useCallback(async () => {

        setVisibleMsg(false)
        setLoadingCancelItemVenda(true)

        try {

            setLinhaSelecionada(0)

            const resp = await VendasService.CancelarVendaItem(idVenda, numItem)

            if (resp.error === true) {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage(resp.msg || "")
                    clearTimeout(timer)
                }, 250)

            } else {

                setLinhasCanceladas((prevLinhas: any) => {
                    if (prevLinhas.includes(numItem)) {
                        // Se já estiver cancelada, remove da lista
                        return prevLinhas.filter((id: any) => id !== numItem)
                    } else {
                        // Caso contrário, adiciona à lista
                        return [...prevLinhas, numItem]
                    }
                })

                setTotalItens(resp.data.qtd_itens)
                setSubTotal(Funcoes.numberFormat(resp.data.vl_liquido, 'currency'))
                setNumItem(0)

                setVisibleCancelItemVenda(false)
            }

            Inputfocus()

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao cancelar o item da venda")

        } finally {
            setLoadingCancelItemVenda(false)
        }

    }, [idVenda, numItem])

    const fecharModalCancelarVendaItem = useCallback(() => {

        setVisibleCancelItemVenda(false)
        setVisibleMsg(false)

        const timer = setTimeout(() => {
            Inputfocus()
            clearTimeout(timer)
        }, 0)
    }, [])

    //-------------------------------------------------------------------------------- FUNÇÕES DA TELA DE VENDAS --------------------------------------------------------------
    const codBarraChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCodBarra(e.target.value)
    }

    const salvarVendaItem = async (id: number) => {

        setVisibleMsg(false)

        try {

            if (codBarra != '') {

                const numItem = prodVendas.length + 1

                const match = codBarra.match(/^\d+\*/)

                const numero = match ? match[0].slice(0, -1) : ''

                let itens: any = {
                    id_venda: id,
                    cod_barra: codBarra.replace(/^\d+\*/, ""),
                    qtde: parseInt(numero) || 1,
                    numItem: numItem
                }

                const resp = await VendasService.SaveItemVenda(itens)

                if (resp.error) {

                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Código de barras não encontrado")

                } else {

                    let itensLista: any = {
                        id_venda: id,
                        id_produto: resp.data.v_item.id_produto,
                        desc_prod: resp.data.v_item.desc_prod,
                        cod_barra: codBarra.replace(/^\d+\*/, ""),
                        qtde: parseInt(numero) || 1,
                        vl_unit: resp.data.v_item.vl_unit || 0,
                        vl_tot: resp.data.v_item.vl_tot || 0,
                        numItem: numItem
                    }

                    setProdVendas([itensLista, ...prodVendas])

                    setTotalItens(resp.data.venda.qtd_itens)
                    setSubTotal(Funcoes.numberFormat(resp.data.venda.vl_liquido, 'currency'))
                    setSubTotalCopy(Funcoes.numberFormat(resp.data.venda.vl_bruto, 'currency'))
                }

            } else {

                const timer = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Código de barras não informado")
                    clearTimeout(timer)
                }, 250)

            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao lançar o produto na venda")

        } finally {

            setLoading(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 0)
        }
    }

    const handleClick = (item: any, id: any) => {

        setLinhaSelecionada(id === linhaSelecionada ? null : id)

        if (id === linhaSelecionada) {

            setNumItem(0)

        } else {

            setNumItem((item.numItem || item.nitem))
        }
    }

    useEffect(() => {

        const handleKeyPress = async (event: any) => {

            const modalStates = [
                visibleBuscarProd,
                visibleCancelItemVenda,
                visibleIdentificarCli,
                loading,
            ]

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && modalStates.every(state => !state)) {

                setLoading(true)

                try {

                    if (idVenda === 0) {

                        setVisibleMsg(false)

                        const resp = await VendasService.SaveVenda()

                        if (resp.error) {

                            const timer = setTimeout(() => {
                                setVisibleMsg(true)
                                setMessageType("DANGER")
                                setMessage(resp.msg || "")
                                clearTimeout(timer)
                            }, 250)

                        } else {

                            setIdVenda(resp.data.id || 0)
                            salvarVendaItem(resp.data.id || 0)
                        }

                    } else {
                        salvarVendaItem(idVenda)
                    }

                    setCodBarra("")

                } catch (error) {

                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage("Houve um erro ao iniciar a venda")
                    setLoading(false)

                    const timer = setTimeout(() => {
                        Inputfocus()
                        clearTimeout(timer)
                    }, 0)

                }
            }
        }

        const handleKeyPressF4 = (event: any) => {

            if (event.code === "F4") {

                const modalStates = [
                    visibleCancelItemVenda,
                    visibleIdentificarCli,
                ]

                if (modalStates.every(state => !state)) {
                    //abrirBuscarProduto()
                }
            }
        }

        const handleKeyPressF8 = (event: any) => {

            if (event.code === "F8") {
                const modalStates = [
                    visibleBuscarProd,
                    visibleCancelItemVenda,
                    visibleIdentificarCli,
                ]

                if (modalStates.every(state => !state)) {
                    setVisibleMsg(false)

                    if (idVenda > 0) {
                        abrirIdentificarCliente()
                    } else {
                        const timer = setTimeout(() => {
                            setVisibleMsg(true)
                            setMessageType("DANGER")
                            setMessage("É necessário abrir uma venda primeiro")
                            clearTimeout(timer)
                        }, 250)
                    }
                }
            }
        }

        const handleKeyDown = (event: any) => {

            const modalStates = [
                visibleBuscarProd,
                visibleCancelItemVenda,
                visibleIdentificarCli,
            ]

            if (modalStates.every(state => !state)) {

                const { key } = event

                if (key === 'ArrowUp' || key === 'ArrowDown') {
                    event.preventDefault()

                    let nextIndex

                    if (key === 'ArrowUp') {

                        nextIndex = linhaSelecionada === 0 ? prodVendas.length : linhaSelecionada + 1

                        if (nextIndex > prodVendas.length) {
                            setNumItem(0)
                        } else {
                            setNumItem(nextIndex)
                        }

                    } else {
                        nextIndex = linhaSelecionada === 1 ? 1 : linhaSelecionada === 0 ? prodVendas.length : linhaSelecionada - 1
                        setNumItem(nextIndex)
                    }

                    const element = document.getElementById(`produto-lancado-condicional-${(prodVendas.length + 1) - nextIndex}`)
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest'
                        })
                    }

                    setLinhaSelecionada(Math.max(0, Math.min(nextIndex, prodVendas.length)))

                }
            }

        }

        const handleMouseUp = (event: any) => {

            const modalStates = [
                visibleBuscarProd,
                visibleCancelItemVenda,
                visibleIdentificarCli,
            ]

            if ((event.button === 0 || event.button === 1 || event.button === 2) && modalStates.every(state => !state)) {
                Inputfocus()
            }
        }

        document.addEventListener('keydown', handleKeyPress)
        document.addEventListener('keydown', handleKeyPressF4)
        document.addEventListener('keydown', handleKeyPressF8)
        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('mouseup', handleMouseUp)

        return () => {
            document.removeEventListener('keydown', handleKeyPress)
            document.removeEventListener('keydown', handleKeyPressF4)
            document.removeEventListener('keydown', handleKeyPressF8)
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('mouseup', handleMouseUp)
        }

    }, [idVenda, loading, codBarra, linhaSelecionada, prodVendas.length, visibleBuscarProd, visibleCancelItemVenda, visibleIdentificarCli])

    useEffect(() => {
        getAttributes()
    }, [])

    const getAttributes = async () => {
        setLoading(true)

        try {

            if (idDaVenda && parseInt(idDaVenda) > 0) {

                const relatorio = {
                    id_venda: idDaVenda,
                }

                const attr = await VendasService.ConsultarVendas(relatorio)

                if (attr) {
                    setProdVendas((prev) => [...(attr.data[0]?.itens || [])].reverse());
                    setIdVenda(attr.data[0]?.id || 0)
                    setTotalItens(attr.data[0]?.qtd_itens || 0)
                    setSubTotal(attr.data[0]?.vl_liquido ? Funcoes.numberFormat(attr.data[0].vl_liquido, 'currency') : Funcoes.numberFormat(0, "currency"))
                }
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage("Houve um erro ao retornar os dados da venda")

        } finally {
            setLoading(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 250)
        }

    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("cod_barra")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
        //Inputfocus()
    }

    // ---------------------------------------------------------------- USEEFFECT DE ALTURA --------------------------------------------------------------
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerHeight <= 600)

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerHeight <= 600)
        }

        window.addEventListener('resize', handleResize)

        // Limpeza do event listener ao desmontar o componente
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    //----------------------------------------------------------------- FOCUS --------------------------------------------------------------------------------------//
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [])

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} flex flex-row`}>

                        <div className={`flex items-center w-auto`}>
                            <IoCreate className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Condicional</span>
                        </div>

                        <div className={`flex justify-end items-center w-full text-slate-700 dark:text-slate-200`}>

                            <span className={`text-[15px] mx-4 font-semibold`}>
                                ( F8 ) Fechar a venda condicional
                            </span>

                        </div>

                    </div>

                    <div className={`bg-white dark:bg-slate-600 py-4 mt-2 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-md cursor-default flex flex-row items-center`}>

                        <div className={`relative w-[80%] pl-4`}>
                            <input id="cod_barra" className={`${classInput} ${classInputDark} text-[18px]`} type="text" placeholder=' ' autoComplete="off" value={codBarra} onChange={codBarraChange} disabled={loading} />
                            <label htmlFor="cod_barra" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ml-4`}>Código de barras</label>
                        </div>

                        <div className={`relative w-[20%] ml-4 pr-4`}>
                            <input id="num_itens" className={`${classInput} ${classInputDark} text-[18px] cursor-not-allowed disabled:opacity-100 text-end`} type="text" placeholder=' ' autoComplete="off" value={totalItens} disabled={true} />
                            <label htmlFor="num_itens" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total itens</label>
                        </div>

                    </div>

                    <div className={`flex flex-row`}>

                        <div className={`w-full ${isSmallScreen ? '' : 'xl:w-[80%] pr-2'} flex flex-col`}>

                            <div className={`w-full`}>

                                <div className={`bg-white dark:bg-slate-600 border border-b-0 dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 px-1 pt-1 mt-2 ${prodVendas.length >= 7 && isSmallScreen ? `pr-4` : prodVendas.length >= 18 ? `pr-4` : ``}  rounded-t-md`}>

                                    <ul className={`w-full h-full bg-blue-800 dark:bg-[#3498DB] text-white `}>

                                        <li className={`h-full border border-white dark:border-slate-600`}>

                                            <div className={`w-full flex flex-row h-10 `}>

                                                <div className={`flex items-center w-[10%] h-full border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Item</span>
                                                </div>

                                                <div className={`flex items-center w-[50%] h-full border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Descrição</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[12%] h-full border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Qtd.</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[13%] h-full border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Unit.</span>
                                                </div>

                                                <div className={`flex items-center justify-end w-[15%] h-full border border-slate-300  dark:border-slate-700`}>
                                                    <span className={`px-2`}>Total</span>
                                                </div>

                                            </div>

                                        </li>

                                    </ul>

                                </div>

                            </div>

                            <div className={`${isSmallScreen ? 'h-[250px]' : 'h-[600px]'} bg-white dark:bg-slate-600 px-1 border border-t-0 dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-b-md overflow-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin cursor-default`}>

                                <ul className={`w-full h-full bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                    {prodVendas.length > 0 &&

                                        prodVendas.map((item, index) => {

                                            const isCancelled = linhasCanceladas.includes((item.numItem || item.nitem))

                                            return (

                                                <li key={item.numItem || item.nitem} tabIndex={0} id={`produto-lancado-condicional-${(prodVendas.length + 1) - (item.numItem || item.nitem)}`} onClick={() => handleClick(item, (item.numItem || item.nitem))} className={`w-full h-auto duration-150 transition-all focus:outline-none border-2 ${(item.numItem || item.nitem) === linhaSelecionada && isCancelled ? 'border-red-600 dark:border-red-300' : (item.numItem || item.nitem) === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} ${isCancelled ? ' bg-red-500 dark:bg-red-500  text-white ' : 'hover:bg-slate-200 dark:hover:bg-slate-500 '} cursor-pointer`}>

                                                    <div className={`w-full flex flex-row h-[30px] `}>

                                                        <div className={`flex items-center w-[10%] break-all  border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.numItem || item.nitem}</span>
                                                        </div>

                                                        <div className={`flex items-center w-[50%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{item.desc_prod}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[12%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{Funcoes.numberFormat(item.qtde, 'decimal')}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[13%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{Funcoes.numberFormat(item.vl_unit, 'currency')}</span>
                                                        </div>

                                                        <div className={`flex items-center justify-end w-[15%] break-all border border-slate-300 dark:border-slate-700`}>
                                                            <span className={`px-2`}>{Funcoes.numberFormat(item.vl_tot, 'currency')}</span>
                                                        </div>

                                                    </div>

                                                </li>
                                            )
                                        })
                                    }

                                </ul>

                            </div>

                        </div>

                        <div className={`${isSmallScreen ? 'hidden' : 'xl:block xl:w-[20%]'} bg-white dark:bg-slate-600 mt-2 pt-4 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-md cursor-default`}>

                            <div className={`relative p-2 `}>
                                <input id="subTotal" className={`${classInput} ${classInputDark} h-[90px] text-[25px] xl:text-[35px] cursor-not-allowed disabled:opacity-100 text-end`} type="text" placeholder=' ' value={subTotal} autoComplete="off" disabled={true} />
                                <label htmlFor="subTotal" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} mt-2 ml-2`}>SubTotal</label>
                            </div>

                            <div className={`p-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirModalCancelarVendaItem} data-tooltip-id={'tooltip-btn-cancelItemVenda'} id={'btn-cancelItemVenda'}>

                                    <TbPackageOff size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        CANCELAR ITEM DA VENDA
                                    </span>

                                </button>
                            </div>

                            <div className={`p-2`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirIdentificarCliente} data-tooltip-id={'tooltip-btn-cancelItemVenda'} id={'btn-cancelItemVenda'}>

                                    <MdPointOfSale size={"22px"} className={`flex justify-start w-[10%]`} />

                                    <span className={`w-[90%]`}>
                                        FECHAR VENDA CONDICIONAL
                                    </span>

                                </button>
                            </div>

                        </div>

                    </div>

                    <div className={`${isSmallScreen ? '' : 'hidden'} h-[80px] dark:text-white bg-white dark:bg-slate-600 mt-2 border dark:border-slate-800 shadow-sm shadow-slate-400 dark:shadow-slate-800 rounded-md cursor-default flex items-center`}>

                        <div className={`w-full grid grid-cols-12 gap-2 px-2`}>

                            <div className={`relative col-span-1`}>
                                <button tabIndex={-1} className={`${classbtColunasAzul}  text-[13px]`} onClick={abrirModalCancelarVendaItem} data-tooltip-id={'tooltip-btn-cancelItemVenda'} id={'btn-cancelItemVenda'}>

                                    <TbPackageOff size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        CANCELAR ITEM DA VENDA
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-cancelItemVenda'} anchorSelect={'#btn-cancelItemVenda'} positionStrategy="fixed" place='top' >
                                            <span>CANCELAR ITEM DA VENDA</span>
                                        </Tooltip>
                                    }

                                </button>
                            </div>

                            <div className={`relative col-span-1`}>

                                <button tabIndex={-1} className={`${classbtColunasAzul} text-[13px]`} onClick={abrirIdentificarCliente} data-tooltip-id={'tooltip-btn-fecharVenda'} id={'btn-fecharVenda'} >

                                    <MdPointOfSale size={"22px"} className={`flex justify-start w-full`} />

                                    <span className={`w-[90%] hidden`}>
                                        FECHAR VENDA CONDICIONAL
                                    </span>

                                    {isSmallScreen &&
                                        <Tooltip style={{ backgroundColor: user.modeDark === 'dark' ? '#B6B060' : '#166794' }} id={'tooltip-btn-fecharVenda'} anchorSelect={'#btn-fecharVenda'} positionStrategy="fixed" place='top-end' >
                                            <span> FECHAR VENDA CONDICIONAL</span>
                                        </Tooltip>
                                    }

                                </button>
                            </div>

                            <div className={`relative col-span-6`}>
                                <input id="subTotalVenda" className={`${classInput} ${classInputDark} w-full h-[45px] text-[25px] xl:text-[35px] cursor-not-allowed text-end`} type="text" placeholder=' ' value={subTotal} autoComplete="off" disabled={true} />
                                <label htmlFor="subTotalVenda" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>SubTotal</label>
                            </div>

                        </div>

                    </div>

                    {/*
                    <ModalBuscaProduto
                        visible={visibleBuscarProd}
                        visible_Modal_Abrir_Grade_Venda={visible_Modal_Abrir_Grade_Venda}
                        loading={loading}
                        stringDesc={codBarra.replace(/^\d+\/, "")} TEM UM ASTERISCO ENTRE AS \/
                        onVisibleOpen={abrirModalGrade}
                        onDadosId={dadosDoProd}
                        consultarCodBarraEvent={preencherDados}
                        closeModalEvent={fecharModalBuscarProduto}
                    />
                    */}
                    
                    {/*
                    <ModalAbrirGradeVenda
                        visible={visible_Modal_Abrir_Grade_Venda}
                        loading={loading}
                        idProd={idProd}
                        lancarCodBarras={preencherDados}
                        closeModalEvent={fecharModalGrade}
                    />
                    */}

                    <ModalIdentificarCliente
                        visible={visibleIdentificarCli}
                        loading={loadingIdentifcarCli}
                        idVenda={idVenda.toString()}
                        identificarConsumidorEvent={identificarConsumidor}
                        closeModalEvent={fecharModalIdentificacaoCliente}
                    />

                    <ModalCancelVendaItem
                        visible={visibleCancelItemVenda}
                        loading={loadingCancelItemVenda}
                        buttonConfirmClick={cancelarVendaItem}
                        closeModalEvent={fecharModalCancelarVendaItem}
                    />

                </div>

            </div>

        </Template>
    )
})